'use client';

import React, { useState } from 'react';

const ReviewsPage: React.FC = () => {
  const reviews = [
    {
      name: 'Rebecca',
      meta: 'Parent · Grade 12 Social/ELA',
      stars: '★★★★★',
      text: 'Bailey has been an excellent tutor for my son in Grade 12 Social Studies and English Language Arts. She has a strong ability to explain concepts clearly and break down challenging material in a way that is easy to understand. My son felt more confident in both his writing and exam preparation after working with Bailey. She is patient, reliable, and genuinely invested in student success. I would highly recommend Bailey to any parent looking for a supportive and effective tutor for their child. Thank you Bailey.',
      emoji: '👩',
    },
    {
      name: 'Danielle',
      meta: 'Parent · Grade 9 Diploma Prep',
      stars: '★★★★★',
      text: 'Bailey helped my daughter go from a 56% to a 77% within just a couple of months. Her focused approach and ability to identify areas to work on was what made the difference for my daughter.',
      emoji: '👩',
    },
    {
      name: 'Nicole',
      meta: 'Parent · Grade 5-7 LA/Social Studies',
      stars: '★★★★★',
      text: "My son, who's on the autism spectrum, began tutoring with Bailey from Stellar Scholar in January 2023. During my IPP meeting with his teacher last Monday, I was told that his writing had improved significantly. Thank you, Bailey, for your time, dedication and flexibility, without you my son wouldn't be where he is academically today, ready for junior high.",
      emoji: '👩',
    },
    {
      name: 'James',
      meta: 'University Student · English',
      stars: '★★★★★',
      text: 'I was struggling with essay writing in my first year of university. After just a few sessions, my writing improved dramatically. Highly recommend!',
      emoji: '👨',
    },
    {
      name: 'Linda',
      meta: 'Adult Learner · GED Prep',
      stars: '★★★★★',
      text: 'I never thought I could go back to school at 45, but Stellar Scholar made it possible. Patient, encouraging, and incredibly knowledgeable.',
      emoji: '👩',
    },
    
  ];

  const [formData, setFormData] = useState({ name: '', role: '', rating: '5', review: '' });
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('https://formspree.io/f/xnjrjgbq', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(formData),
      });
      if (res.ok) {
        setStatus('success');
        setFormData({ name: '', role: '', rating: '5', review: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  const inputStyle: React.CSSProperties = {
    width: '100%',
    padding: '0.85rem 1rem',
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: 10,
    color: '#fff',
    fontSize: '0.9rem',
    outline: 'none',
    boxSizing: 'border-box',
  };

  return (
    <section
      style={{
        padding: '5rem 1.25rem',
        maxWidth: 1200,
        margin: '0 auto',
        position: 'relative',
        zIndex: 1,
      }}
    >
      {/* Header */}
      <div style={{ textAlign: 'center', maxWidth: 700, margin: '0 auto 3rem' }}>
        <div className="section-label">Student Reviews</div>
        <h2 className="section-title" style={{ fontFamily: "'Playfair Display', serif" }}>
          What Our Students Say
        </h2>
        <div className="gold-line" style={{ margin: '1.5rem auto' }} />
      </div>

      {/* Overall Score */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '1.5rem',
          margin: '3rem auto',
          padding: '2rem 1.5rem',
          background: 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: 20,
          maxWidth: 600,
          boxSizing: 'border-box',
        }}
      >
        <div
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: '5rem',
            fontWeight: 900,
            color: '#f4c430',
            lineHeight: 1,
          }}
        >
          5.0
        </div>
        <div style={{ textAlign: 'left' }}>
          <div style={{ fontSize: '1.8rem', color: '#f4c430', marginBottom: '0.3rem' }}>★★★★★</div>
          <div style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.5)' }}>Based on 100+ reviews</div>
        </div>
      </div>

      {/* Reviews Grid */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '1.5rem',
        }}
      >
        {reviews.map((review, i) => (
          <div
            key={i}
            style={{
              background: 'rgba(255,255,255,0.04)',
              border: '1px solid rgba(255,255,255,0.08)',
              borderRadius: 16,
              padding: '1.8rem',
              transition: 'all 0.3s',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.2rem' }}>
              <div
                style={{
                  width: 48, height: 48, borderRadius: '50%',
                  background: 'linear-gradient(135deg, rgba(244,196,48,0.3), rgba(244,196,48,0.1))',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '1.3rem', flexShrink: 0,
                }}
              >
                {review.emoji}
              </div>
              <div>
                <div style={{ fontWeight: 600, fontSize: '0.95rem', marginBottom: '0.2rem', color: '#fff' }}>
                  {review.name}
                </div>
                <div style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.45)' }}>
                  {review.meta}
                </div>
              </div>
            </div>
            <div style={{ color: '#f4c430', fontSize: '0.9rem', marginBottom: '0.8rem' }}>
              {review.stars}
            </div>
            <p style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.7)', lineHeight: 1.7, fontStyle: 'italic' }}>
              &ldquo;{review.text}&rdquo;
            </p>
          </div>
        ))}
      </div>

      {/* Leave a Review Form */}
      <div
        style={{
          marginTop: '4rem',
          padding: '2rem 1.5rem',
          background: 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: 20,
          maxWidth: 680,
          marginLeft: 'auto',
          marginRight: 'auto',
          boxSizing: 'border-box',
          width: '100%',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div className="section-label">Share Your Experience</div>
          <h3
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: '1.8rem',
              fontWeight: 700,
              color: '#fff',
              margin: '0.5rem 0 0',
            }}
          >
            Leave a Review
          </h3>
          <div className="gold-line" style={{ margin: '1rem auto' }} />
        </div>

        {status === 'success' ? (
          <div
            style={{
              textAlign: 'center',
              padding: '2rem',
              color: '#f4c430',
              fontSize: '1rem',
            }}
          >
            <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>⭐</div>
            <p style={{ fontWeight: 600, marginBottom: '0.4rem' }}>Thank you for your review!</p>
            <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.88rem' }}>
              We appreciate you taking the time to share your experience.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.2rem' }}>
            <div className="review-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.82rem', color: 'rgba(255,255,255,0.55)', marginBottom: '0.4rem' }}>
                  Your Name *
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  placeholder="e.g. Sarah M."
                  value={formData.name}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.82rem', color: 'rgba(255,255,255,0.55)', marginBottom: '0.4rem' }}>
                  Role / Subject
                </label>
                <input
                  type="text"
                  name="role"
                  placeholder="e.g. Parent · Grade 8 Math"
                  value={formData.role}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.82rem', color: 'rgba(255,255,255,0.55)', marginBottom: '0.4rem' }}>
                Rating *
              </label>
              <select
                name="rating"
                required
                value={formData.rating}
                onChange={handleChange}
                style={{ ...inputStyle, cursor: 'pointer' }}
              >
                <option value="5">★★★★★ — 5 Stars</option>
                <option value="4">★★★★☆ — 4 Stars</option>
                <option value="3">★★★☆☆ — 3 Stars</option>
                <option value="2">★★☆☆☆ — 2 Stars</option>
                <option value="1">★☆☆☆☆ — 1 Star</option>
              </select>
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.82rem', color: 'rgba(255,255,255,0.55)', marginBottom: '0.4rem' }}>
                Your Review *
              </label>
              <textarea
                name="review"
                required
                rows={5}
                placeholder="Tell us about your experience with Stellar Scholar..."
                value={formData.review}
                onChange={handleChange}
                style={{ ...inputStyle, resize: 'vertical' }}
              />
            </div>

            {status === 'error' && (
              <p style={{ color: '#ff6b6b', fontSize: '0.85rem', margin: 0 }}>
                Something went wrong. Please try again.
              </p>
            )}

            <button
              type="submit"
              disabled={status === 'sending'}
              style={{
                padding: '0.9rem 2rem',
                background: status === 'sending' ? 'rgba(244,196,48,0.5)' : 'linear-gradient(135deg, #f4c430, #e6a800)',
                color: '#1a1a2e',
                fontWeight: 700,
                fontSize: '0.95rem',
                border: 'none',
                borderRadius: 10,
                cursor: status === 'sending' ? 'not-allowed' : 'pointer',
                transition: 'all 0.3s',
                letterSpacing: '0.03em',
              }}
            >
              {status === 'sending' ? 'Submitting…' : 'Submit Review'}
            </button>
          </form>
        )}
      </div>
      <style>{`
        @media (max-width: 500px) {
          .review-form-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default ReviewsPage;
